/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDevicesPcOff = createReactComponent("outline", "devices-pc-off", "IconDevicesPcOff", [["path", { "d": "M9 9v10h-6v-14h2", "key": "svg-0" }], ["path", { "d": "M13 9h9v7h-2m-4 0h-4v-4", "key": "svg-1" }], ["path", { "d": "M14 19h5", "key": "svg-2" }], ["path", { "d": "M17 17v2", "key": "svg-3" }], ["path", { "d": "M6 13v.01", "key": "svg-4" }], ["path", { "d": "M6 16v.01", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

export { IconDevicesPcOff as default };
//# sourceMappingURL=IconDevicesPcOff.mjs.map
